import { gql } from '@apollo/client'

const UPDATE_ELIGIBLE_PERSON = gql`
  mutation EligiblePersonUpdate(
    $id: String!
    $updateData: EligiblePersonUpdateDataInput!
  ) {
    eligiblePersonUpdate(personId: $id, updateData: $updateData) {
      eligiblePerson {
        id
      }
    }
  }
`

const SCRUB_ELIGIBLE_PERSON = gql`
  mutation ScrubEligiblePerson($eligiblePersonId: ID!) {
    scrubEligiblePerson(eligiblePersonId: $eligiblePersonId) {
      message
      requestOk
    }
  }
`

const REFRESH_ELIGIBLE_PERSON_MAGIC_LINK = gql`
  mutation RefreshEligiblePersonToken($eligiblePersonId: ID!) {
    eligiblePersonRefreshToken(eligiblePersonId: $eligiblePersonId) {
      eligiblePerson {
        magicLink
      }
    }
  }
`

export {
  REFRESH_ELIGIBLE_PERSON_MAGIC_LINK,
  SCRUB_ELIGIBLE_PERSON,
  UPDATE_ELIGIBLE_PERSON,
}
